import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  company: {
    list: [],
    listLoading: false,
    listMinimal: [],
  },
};

export const mutations = {
  COMPANY_SET_LIST(state, list) {
    state.company.list = list;
  },
  COMPANY_SET_LIST_LOADING(state, isLoading) {
    state.company.listLoading = isLoading;
  },
  COMPANY_SET_LIST_MINIMAL(state, list) {
    state.company.listMinimal = list;
  },
};

export const getters = {
  getCompaniesList: state => state.company.list,
  getCompaniesListMinimal: state => state.company.listMinimal,
};

export const actions = {
  fetchPatCompanyList({ commit }) {
    commit('COMPANY_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/company`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { companies } = response;
          commit('COMPANY_SET_LIST_LOADING', false);
          commit('COMPANY_SET_LIST', companies);
        });
      })
      .catch((error) => {
        commit('COMPANY_SET_LIST_LOADING', false);
        commit('COMPANY_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchPatCompanyListMinimal({ commit }) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/company/list/minimal`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { companies } = response;
          commit('COMPANY_SET_LIST_MINIMAL', companies);
        });
      })
      .catch((error) => {
        commit('COMPANY_SET_LIST_MINIMAL', []);

        return Promise.reject(error);
      });
  },
  fetchPatCompanyAll({ dispatch }) {
    dispatch('fetchPatCompanyList');
  },
  fetchPatCompanyNvDownloadCsv({ commit }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/security/export/nv/csv`, payload)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
};

const company = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default company;



// WEBPACK FOOTER //
// ./src/store/payout/company.js